import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import ShippingForm from 'components/Cart/Physical/ShippingForm';
import { IOrderBump, IProduct } from 'interfaces/IProductData';
import { enProductType } from 'enums/enProductType';
import { WithStyles } from 'shared/decorators/withStyles';
import { cartService } from 'services/CartService';

interface IState extends IStateBase {
  cartProducts: IProduct[];
}

interface IProps {
  product: IOrderBump;
}

@WithStyles(() => ({
  component: {
    padding: '10px 15px'
  }
}))
export default class OrderBumpShippingForm extends BaseComponent<IState, IProps> {
  componentDidMount() {
    this.observeState({ cartProducts: [] }, cartService.getCart().map(cart => cart.products));
  }

  render() {
    const { product } = this.props;

    if (product.type !== enProductType.PHYSICAL) {
      return null;
    }

    if (!this.state) {
      return null;
    }

    const { cartProducts } = this.state;

    if (cartProducts && cartProducts[0].type === enProductType.PHYSICAL) {
      return null;
    }

    return (
      <div className={this.props.classes.component}>
        <ShippingForm />
      </div>
    );
  }
}
